import React, { useState } from 'react';
import { suggestEmail } from '../utils/emailTypos';
import './EmailInput.css';

// An email box that spots likely typos in the domain and offers a one-tap
// fix — "Did you mean …@gmail.com?" (utils/emailTypos.js). Drop-in for an
// <input type="email">: pass value / onChange(newValue) plus any of the
// usual input props.
const EmailInput = ({ value, onChange, className = '', ...inputProps }) => {
  const [checked, setChecked] = useState(false); // only nag once they've paused / left the box
  const suggestion = checked ? suggestEmail(value) : null;

  return (
    <>
      <input
        type="email"
        autoComplete="email"
        {...inputProps}
        className={className}
        value={value}
        onChange={(e) => { onChange(e.target.value); setChecked(false); }}
        onBlur={(e) => { setChecked(true); inputProps.onBlur?.(e); }}
        onKeyUp={(e) => { if (e.key === 'Enter' || e.key === 'Tab') setChecked(true); inputProps.onKeyUp?.(e); }}
      />
      {suggestion && (
        <p className="email-input-suggest" role="status">
          Did you mean{' '}
          <button type="button" className="email-input-suggest-btn" onClick={() => { onChange(suggestion); setChecked(false); }}>
            {suggestion}
          </button>
          ?
        </p>
      )}
    </>
  );
};

export default EmailInput;
